import { createFileRoute } from '@tanstack/react-router';
import { parseEnv } from '@/helpers/route-utils';
import * as z from 'zod/v4';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_auth/$env/events/$id')({
  params: parseEnv(),
  validateSearch: zodValidator(
    z.object({
      translationSidebarOpen: z.boolean().optional(),
    }),
  ),
});
